import React, {useState, useEffect} from 'react';
import {
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonIcon,
    useIonAlert,
} from '@ionic/react';
import {
    home,
    briefcase,
    heart,
    clipboard,
    calendar,
    newspaper,
    cash,
    logOut, medal,
} from 'ionicons/icons';
import appLogo from '../../theme/images/logo-big.png';
import {useHistory, useLocation} from "react-router";
import {
    actionToGetAllNotification,
    actionToLogoutUserSession
} from "../../apiHelpers/CommonAction";
import useStore from "../../zustand/useStore";
import AdminSendNotificationModal from "../../components/AdminSendNotificationModal";

const menuDesktopTopItems = [
    { label: 'Home', icon: home, pathName: '/dashboard/home' },
    { label: 'Users', icon: home, pathName: '/dashboard/users' },
    { label: 'Jobs', icon: briefcase, pathName: '/dashboard/job-portal' },
    { label: 'Assignments', icon: clipboard, pathName: '/dashboard/assignments' },
    { label: 'Matrimonial', icon: heart, pathName: '/dashboard/matrimonial' },
    { label: 'Events', icon: calendar, pathName: '/dashboard/events' },
    { label: 'Newsletter', icon: newspaper, pathName: '/dashboard/newsletter' },
    { label: 'Membership', icon: medal, pathName: '/dashboard/membership' },
    { label: 'Contribute', icon: cash, pathName: '/dashboard/contribute' },
];


const AdminHeaderAfterLoginComponent = ({hideHeader}) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);
    const {pathname} = useLocation();
    const {userAuthDetail} = useStore();
    const [presentAlert] = useIonAlert();
    const history = useHistory();
    const {userInfo} = userAuthDetail;
    const [notificationSheetOpen,setNotificationSheetOpen] = useState(false);


    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1000);
        window.addEventListener('resize', handleResize);
    }, []);


    const callFunctionToLogoutUser = ()=>{
        presentAlert({
            header: 'Confirm Logout',
            cssClass:"confirm_alert_custom",
            message: 'Are you sure you want to log out?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                },
                {
                    text: 'Yes',
                    handler: () => {
                        actionToLogoutUserSession();
                    },
                },
            ],
        });
    }

    const goToPage =(page)=>{
        history.replace(page);
    }

    useEffect(() => {
        actionToGetAllNotification();
    }, []);

    return (
        <>
            {/* Mobile/Tablet Slide Menu */}
            <IonHeader className={`with_login-header main_app_header ${hideHeader ? 'hide_element' : ''}`}>
                <IonToolbar className="with_login-toolbar">
                    {isMobile && (
                        <IonButtons slot="start">
                            <IonButton className={`with_login-menu-button`}>
                                <div className="profile-avatar">
                                    <div className={"user_name_initial"}>
                                        <div className={"user_name"}>
                                            {userInfo?.name?.substr(0,1).toUpperCase()}
                                        </div>
                                    </div>
                                </div>
                            </IonButton>
                        </IonButtons>
                    )}
                    {isMobile ? (
                            <div slot="start" className="with_login-title_in_center_mob">
                                <img src={appLogo} alt="Logo" className="with_login-logo-mob"/>
                            </div>
                        )
                        : (
                            <IonTitle slot="start" className="with_login-title">
                                <img src={appLogo} alt="Logo" className="with_login-logo"/>
                            </IonTitle>
                        )}

                    {!isMobile && (
                        <IonButtons slot="start" className="with_login-desktop-menu">
                            {menuDesktopTopItems.map((item, index) => (
                                <div
                                    key={index}
                                    className="menu-item-wrapper desktop-menu-top"
                                >
                                    <div
                                        className={`menu-item ${
                                            pathname === item?.pathName ? 'active' : ''
                                        }`}
                                        onClick={() => goToPage(item.pathName)}
                                    >
                                        <span>{item.label}</span>
                                        {item.children && <span className="arrow">▾</span>}
                                    </div>
                                </div>
                            ))}
                        </IonButtons>
                    )}
                    <IonButtons slot="end" className="with_login-icons">
                        <IonButton onClick={()=>setNotificationSheetOpen(true)} className="header_button">
                            <div className="notification-icon">
                                Notify
                            </div>
                        </IonButton>
                        <IonButton onClick={() => callFunctionToLogoutUser()} className="header_button">
                            <div className="notification-icon">
                                <IonIcon icon={logOut}/>
                            </div>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                <AdminSendNotificationModal isOpen={notificationSheetOpen} onDismiss={()=>setNotificationSheetOpen(false)} />
            </IonHeader>
        </>
    );
};

export default AdminHeaderAfterLoginComponent;